import React from "react";
import { Pie, PieChart } from "recharts";

import {
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
} from "@/components/ui/chart"

export default function ComponentSubsChart({ data, total, active }) {

    const chartConfig = {
        subscription: {
            label: "Subscription",
        },
        chrome: {
            label: "Chrome",
            color: "var(--chart-1)",
        },
        safari: {
            label: "Safari",
            color: "var(--chart-2)",
        },
        firefox: {
            label: "Firefox",
            color: "var(--chart-3)",
        },
    };

    return (
        <ChartContainer config={chartConfig} className="mx-auto aspect-square max-h-[250px]">
            <PieChart>
                <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
                <Pie data={data} dataKey="subscription" nameKey="status" innerRadius={80} strokeWidth={4}></Pie>
                <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="fill-gray-900 font-bold text-3xl">
                    {active}/{total}
                </text>
            </PieChart>
        </ChartContainer>
    )
}
